const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.ozminerals.forwoodsafety.com',
    USER_TOKEN_URL: 'https://2haf40mph8.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-2',
    URL: 'https://fjvdqx7m42.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.ozminerals.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.ozminerals.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.ozminerals.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.ozminerals.forwoodsafety.com',
    WEBSOCKET: 'wss://wg3taxg1u2.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
